import DialogModal from '@/components/DialogModal';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onCloseConfirmRepeatActionModal: () => void;
  onConfirm: () => void;
  repeatTimes: number;
};

const ConfirmRepeatActionModal = ({ isOpen, repeatTimes, onCloseConfirmRepeatActionModal, onConfirm }: Props) => {
  const { t } = useTranslation('ConfirmRepeatActionModal');
  return (
    <DialogModal
      isOpen={isOpen}
      title={t('title.confirmCreateActions', { count: repeatTimes, plural: repeatTimes > 1 ? 's' : '' })}
      message={t('messages.changeWarning')}
      onCancel={onCloseConfirmRepeatActionModal}
      onConfirm={onConfirm}
      confirmText={t('buttons.confirmCreate', { count: repeatTimes, plural: repeatTimes > 1 ? 's' : '' })}
      cancelText={t('buttons.cancel')}
    />
  );
};

export default ConfirmRepeatActionModal;
